import configureAppStore from "../redux/store";
import { DeviceUUID } from "device-uuid";

import { BASE_URL } from "./routes";
import { clearAll, setAccessToken } from "../redux/userDataSlice";

const handleLogout = () => {
  console.error("Authentication failed. Logging out...");
  configureAppStore.dispatch(clearAll());
  localStorage.clear();
  window.location.href = "/login";
};

export const Method = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export const Status = {
  SUCCESS: 200,
  ERROR: 400,
  AUTHENTICATION_FAIL: 401,
  NOT_FOUND: 400,
};

export const callApi = async (
  method,
  Url,
  bodyParams,
  setloading,
  onSuccess,
  onError,
  count = 0
) => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    let id = new DeviceUUID().get();
    localStorage.setItem("deviceId", id);
    deviceId = id;
  }

  let token = configureAppStore.getState().userDataSlice.token ?? false;
  let refreshToken = configureAppStore.getState().userDataSlice.refreshToken;

  const isFormData = bodyParams instanceof FormData;

  const headers = {
    Accept: "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
  };

  const body =
    method === "GET" || method === "DELETE"
      ? null
      : isFormData
      ? bodyParams
      : JSON.stringify(bodyParams);

  const fetchObject = {
    method,
    headers,
    ...(body ? { body } : {}),
  };

  try {
    setloading(true);
    const response = await fetch(Url, fetchObject);
    const responseJson = await response.json();

    if (responseJson.status === 401) {
      if (count < 4 && refreshToken) {
        const refreshHeaders = {
          Accept: "application/json",
          "Content-Type": "application/json",
          ...(token && { Authorization: `Bearer ${token}` }),
        };
        const refreshBody = JSON.stringify({
          device: { id: deviceId },
          refreshToken,
        });

        fetch(`${BASE_URL}auth/refresh-token`, {
          method: "POST",
          headers: refreshHeaders,
          body: refreshBody,
        })
          .then(async (res) => {
            const resJson = await res.json();
            if (!res.ok) {
              throw new Error("Refresh token failed");
            }
            configureAppStore.dispatch(setAccessToken(resJson.accessToken));
            callApi(
              method,
              Url,
              bodyParams,
              setloading,
              onSuccess,
              onError,
              count + 1
            );
          })
          .catch((err) => {
            handleLogout();
          });
      } else {
        handleLogout();
      }
    } else if (response.ok || responseJson?.success) {
      onSuccess(responseJson);
      setloading(false);
    } else {
      onError(responseJson);
      setloading(false);
    }
  } catch (error) {
    console.error("Fetch error:", error);
    setloading(false);
    onError({ success: false, message: "Unexpected error occurred." });
  }
};
